/**
 * Storage adapter exports and factory
 */

export * from './types';
export { MemoryStorageAdapter } from './memory-adapter';
export { RedisStorageAdapter } from './redis-adapter';

import type { StorageAdapter, StorageConfig } from './types';
import { MemoryStorageAdapter } from './memory-adapter';
import { RedisStorageAdapter } from './redis-adapter';
import type { RedisClient } from './redis-adapter';

/**
 * Create a storage adapter based on configuration
 */
export async function createStorageAdapter(config?: StorageConfig): Promise<StorageAdapter> {
  if (!config || config.type === 'memory') {
    return new MemoryStorageAdapter();
  }

  if (config.type === 'custom' && config.custom) {
    return config.custom;
  }

  if (config.type === 'redis' && config.redis) {
    // Dynamically import Redis client using a pattern that prevents static analysis
    // This ensures the bundler doesn't try to resolve @upstash/redis at build time
    try {
      // Use variable to prevent static analysis by bundler
      const redisModuleName = '@upstash/redis';
      const redisModule = await import(/* webpackIgnore: true */ redisModuleName);
      const Redis = redisModule.Redis;
      const redis = new Redis({
        url: config.redis.url,
        token: config.redis.token,
      });
      // Upstash Redis client matches our RedisClient interface
      return new RedisStorageAdapter(redis as unknown as RedisClient, config.ttl);
    } catch (error) {
      console.warn(
        '[AgentShield] Redis storage requires @upstash/redis package. Install with: npm install @upstash/redis',
        '\nFalling back to memory storage.'
      );
      return new MemoryStorageAdapter();
    }
  }

  // Default to memory storage
  return new MemoryStorageAdapter();
}
